import { api } from './api';

const loadScript = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const s = document.createElement('script');
  s.src = 'https://checkout.razorpay.com/v1/checkout.js';
  s.onload = resolve; s.onerror = reject;
  document.head.appendChild(s);
});

// Pays Khata dues online. Resolves with the verify result; the webhook also records it if the tab closes.
export async function payKhataOnline({ storeId, storeName, amount, user }) {
  const { data: o } = await api.post('/khata/pay/order', { store_id: storeId, amount });
  await loadScript();
  return new Promise((resolve, reject) => {
    const r = new window.Razorpay({
      key: o.key_id, amount: o.amount, currency: o.currency, order_id: o.razorpay_order_id,
      name: 'BharatCart Khata', description: `Udhaar payment · ${storeName}`,
      prefill: { name: user?.name, contact: user?.phone },
      theme: { color: '#1B5E20' },
      handler: async (resp) => {
        try {
          const { data } = await api.post('/khata/pay/verify', {
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          resolve(data);
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(new Error('Payment cancelled')) },
    });
    r.open();
  });
}
